(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-3d.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-3d.js');

'use strict';

var _svs$lyckoplatsen$dat, _mapCMS$mapSettings, _mapCMS$mapSettings2, _svs$lyckoplatsen$dat2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$tur$lyckoplatsen = svs.tur.lyckoplatsen.map,
  swe = _svs$tur$lyckoplatsen.swe,
  sweRectangleBounds = _svs$tur$lyckoplatsen.sweRectangleBounds,
  isPointInsideSweden = _svs$tur$lyckoplatsen.isPointInsideSweden;
const logger = svs.lyckoplatsen.logger;
const cdn2 = svs.core.config.data.svsconfig.cdn2;
const sweImageBounds = [[70.37, 4.15], [52.82, 29.95]];
const mapCMS = (_svs$lyckoplatsen$dat = svs.lyckoplatsen.data.cms) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.map;
const mapGradientCMS = mapCMS === null || mapCMS === void 0 || (_mapCMS$mapSettings = mapCMS.mapSettings) === null || _mapCMS$mapSettings === void 0 ? void 0 : _mapCMS$mapSettings.backgroundGradient;
const mapCitiesCMS = (mapCMS === null || mapCMS === void 0 ? void 0 : mapCMS.mapCities) || [];
const enable3DMapCMS = mapCMS === null || mapCMS === void 0 ? void 0 : mapCMS.enable3DMap;
const addWeatherCMS = mapCMS === null || mapCMS === void 0 || (_mapCMS$mapSettings2 = mapCMS.mapSettings) === null || _mapCMS$mapSettings2 === void 0 ? void 0 : _mapCMS$mapSettings2.addWeather;
const imageUrl = (_svs$lyckoplatsen$dat2 = svs.lyckoplatsen.data.cms) === null || _svs$lyckoplatsen$dat2 === void 0 || (_svs$lyckoplatsen$dat2 = _svs$lyckoplatsen$dat2.map) === null || _svs$lyckoplatsen$dat2 === void 0 || (_svs$lyckoplatsen$dat2 = _svs$lyckoplatsen$dat2.mapSettings) === null || _svs$lyckoplatsen$dat2 === void 0 || (_svs$lyckoplatsen$dat2 = _svs$lyckoplatsen$dat2.image) === null || _svs$lyckoplatsen$dat2 === void 0 ? void 0 : _svs$lyckoplatsen$dat2.url;
const gradientDefaults = {
  gradientId: 'backgroundGradient',
  type: 'linear',
  cx: '50%',
  cy: '50%',
  r: '12%',
  x1: '100%',
  y1: '72%',
  x2: '0%',
  y2: '28%',
  stops: [{
    offset: '0%',
    color: '#1EA9CF'
  }, {
    offset: '42%',
    color: '#1EA9CF'
  }, {
    offset: '58%',
    color: '#006388'
  }]
};
const gradientCMS = enable3DMapCMS && imageUrl ? _objectSpread(_objectSpread({}, gradientDefaults), {}, {
  stops: [{
    offset: '0%',
    color: (mapGradientCMS === null || mapGradientCMS === void 0 ? void 0 : mapGradientCMS.colorBottomRight) || '#1EA9CF'
  }, {
    offset: '42%',
    color: (mapGradientCMS === null || mapGradientCMS === void 0 ? void 0 : mapGradientCMS.colorBottomRight) || '#1EA9CF'
  }, {
    offset: '58%',
    color: (mapGradientCMS === null || mapGradientCMS === void 0 ? void 0 : mapGradientCMS.colorTopLeft) || '#006388'
  }]
}) : {};
const layerStorage = {
  map: null,
  dashedLayer: null,
  dashedPane: null,
  cityMarkers: [],
  citiesPane: null,
  weatherMarkers: [],
  weatherPane: null,
  imageOverlay: null,
  imagePane: null
};
const init3DMap = map => {
  layerStorage.map = map;
};
const addDashedSwedenBorder = map => {
  const dashedPane = map.createPane('dashed');
  dashedPane.style.zIndex = 550;
  dashedPane.classList.add('leaflet-map-dashed');
  layerStorage.dashedPane = dashedPane;
  if (dashedPane) {
    layerStorage.dashedLayer = leaflet.geoJSON(swe, {
      style() {
        return {
          fillOpacity: 0,
          fillColor: 'transparent',
          color: '#D5FFF0',
          weight: 0.6,
          className: 'lp-geojson lp-geojson-dashed'
        };
      },
      pane: 'dashed'
    }).addTo(map);
  }
};
const addStaticCityMarkers = map => {
  const citiesPane = map.createPane('cities');
  citiesPane.style.zIndex = 550;
  citiesPane.classList.add('leaflet-map-cities');
  layerStorage.citiesPane = citiesPane;
  layerStorage.cityMarkers = [];
  mapCitiesCMS.forEach(city => {
    const size = city.size === 'large' ? 6 : 4.5;
    const cityMarker = leaflet.circleMarker([city.latitude, city.longitude], {
      radius: size,
      fillColor: '#ffffff',
      fillOpacity: 1,
      color: '#000000',
      weight: 1,
      pane: 'cities',
      className: 'city-marker',
      interactive: false
    });
    cityMarker.addTo(map);
    layerStorage.cityMarkers.push(cityMarker);
    if (city.size === 'small') {
      return;
    }
    cityMarker.bindTooltip(city.name, {
      permanent: true,
      direction: 'bottom',
      className: 'city-label',
      offset: [3, -2],
      pane: 'cities'
    });
  });
};
const addWeather = map => {
  const weatherPane = map.createPane('weather');
  weatherPane.style.zIndex = 551;
  weatherPane.classList.add('leaflet-map-weather');
  layerStorage.weatherPane = weatherPane;
  const breakpoint = svs.core.detect.breakpoint.lessThan('sm');
  let numberOfClouds = svsRandom.getRandomInt(2, 5);
  if (breakpoint) {
    numberOfClouds = svsRandom.getRandomInt(2, 3);
  }
  const maxAttempts = 100;
  const cloudCoords = [];
  let totalAttempts = 0;
  for (let i = 0; i < numberOfClouds; i++) {
    let attempts = 0;
    let latitude;
    let longitude;
    do {
      latitude = svsRandom.getRandomInt(0, 1000000) / 1000000 * (sweRectangleBounds[0][0] - sweRectangleBounds[1][0]) + sweRectangleBounds[1][0];
      longitude = svsRandom.getRandomInt(0, 1000000) / 1000000 * (sweRectangleBounds[0][1] - sweRectangleBounds[1][1]) + sweRectangleBounds[1][1];
      attempts++;
    } while (!isPointInsideSweden([latitude, longitude], swe.features[0].geometry.coordinates) && attempts < maxAttempts);
    totalAttempts += attempts;
    if (attempts < maxAttempts) {
      cloudCoords.push([parseFloat(latitude.toFixed(6)), parseFloat(longitude.toFixed(6))]);
    }
  }
  const failedSamples = totalAttempts - cloudCoords.length;
  const failRatePercent = totalAttempts > 0 ? Number((failedSamples / totalAttempts * 100).toFixed(2)) : 0;
  logger.debug('3D map weather cloud placement stats', {
    totalAttempts,
    failRatePercent
  });
  if (failRatePercent > 85 || cloudCoords.length === 0) {
    logger.warn('3D map weather cloud placement quality is low', {
      generatedClouds: cloudCoords.length,
      requestedClouds: numberOfClouds,
      totalAttempts,
      failRatePercent
    });
  }
  let randomOpacity = svsRandom.getRandomInt(1, 4);
  let randomSize = svsRandom.getRandomInt(3, 5);
  if (breakpoint) {
    randomOpacity = svsRandom.getRandomInt(0, 3);
    randomSize = svsRandom.getRandomInt(1, 3);
  }
  layerStorage.weatherMarkers = [];
  cloudCoords.forEach(coords => {
    const cloudIcon = leaflet.divIcon({
      html: "<div class=\"cloud cloud-".concat(svsRandom.getRandomInt(1, 3), " cloud-opacity-").concat(randomOpacity, " cloud-inner-").concat(svsRandom.getRandomInt(1, 3), " cloud-size-").concat(randomSize, " cloud-duration-").concat(svsRandom.getRandomInt(1, 3), "\"><div></div></div>"),
      className: 'leaflet-div-cloud'
    });
    const marker = leaflet.marker(coords, {
      icon: cloudIcon,
      pane: 'weather'
    }).addTo(map);
    layerStorage.weatherMarkers.push(marker);
  });
};
const addImageOverlay = map => {
  if (!imageUrl) {
    logger.warn('3D map image overlay not added: missing CMS image URL');
    return;
  }
  const imagePane = map.createPane('image');
  imagePane.style.zIndex = 549;
  imagePane.classList.add('leaflet-image-overlay');
  layerStorage.imagePane = imagePane;
  layerStorage.imageOverlay = leaflet.imageOverlay("".concat(cdn2).concat(imageUrl), sweImageBounds, {
    opacity: 1,
    zIndex: 200,
    interactive: false,
    pane: 'image'
  }).addTo(map);
};
const addBackground = function (map) {
  var _map$getRenderer;
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!map || !imageUrl) {
    return;
  }
  const svg = (_map$getRenderer = map.getRenderer(map)) === null || _map$getRenderer === void 0 ? void 0 : _map$getRenderer._container;
  if (!svg) {
    return;
  }
  let defs = svg.querySelector('defs');
  if (!defs) {
    defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
    svg.insertBefore(defs, svg.firstChild);
  }
  const _options$gradientId = options.gradientId,
    gradientId = _options$gradientId === void 0 ? gradientCMS.gradientId || gradientDefaults.gradientId : _options$gradientId,
    _options$type = options.type,
    type = _options$type === void 0 ? gradientCMS.type || gradientDefaults.type : _options$type,
    _options$cx = options.cx,
    cx = _options$cx === void 0 ? gradientCMS.cx || gradientDefaults.cx : _options$cx,
    _options$cy = options.cy,
    cy = _options$cy === void 0 ? gradientCMS.cy || gradientDefaults.cy : _options$cy,
    _options$r = options.r,
    r = _options$r === void 0 ? gradientCMS.r || gradientDefaults.r : _options$r,
    _options$x = options.x1,
    x1 = _options$x === void 0 ? gradientCMS.x1 || gradientDefaults.x1 : _options$x,
    _options$y = options.y1,
    y1 = _options$y === void 0 ? gradientCMS.y1 || gradientDefaults.y1 : _options$y,
    _options$x2 = options.x2,
    x2 = _options$x2 === void 0 ? gradientCMS.x2 || gradientDefaults.x2 : _options$x2,
    _options$y2 = options.y2,
    y2 = _options$y2 === void 0 ? gradientCMS.y2 || gradientDefaults.y2 : _options$y2,
    _options$stops = options.stops,
    stops = _options$stops === void 0 ? gradientCMS.stops || gradientDefaults.stops : _options$stops;
  const stopElements = stops.map(stop => "<stop offset=\"".concat(stop.offset, "\" stop-color=\"").concat(stop.color, "\" />")).join('\n');
  const linearGradient = "\n    <linearGradient id=\"".concat(gradientId, "\" x1=\"").concat(x1, "\" y1=\"").concat(y1, "\" x2=\"").concat(x2, "\" y2=\"").concat(y2, "\">\n      ").concat(stopElements, "\n    </linearGradient>\n  ");
  const radialGradient = "\n    <radialGradient id=\"".concat(gradientId, "\" cx=\"").concat(cx, "\" cy=\"").concat(cy, "\" r=\"").concat(r, "\">\n      ").concat(stopElements, "\n    </radialGradient>\n  ");
  const customGradient = type === 'linear' ? linearGradient : radialGradient;
  const existingGradient = defs.querySelector("#".concat(gradientId));
  if (existingGradient) {
    existingGradient.remove();
  }
  defs.insertAdjacentHTML('beforeend', customGradient);
  return gradientId;
};
const add3DMap = function (map) {
  let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$dashed = _ref.dashed,
    dashed = _ref$dashed === void 0 ? true : _ref$dashed,
    _ref$cities = _ref.cities,
    cities = _ref$cities === void 0 ? true : _ref$cities,
    _ref$weather = _ref.weather,
    weather = _ref$weather === void 0 ? addWeatherCMS : _ref$weather,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? true : _ref$image,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? true : _ref$background;
  if (enable3DMapCMS && map) {
    if (dashed) {
      addDashedSwedenBorder(map);
    }
    if (cities) {
      addStaticCityMarkers(map);
    }
    if (weather) {
      addWeather(map);
    }
    if (image) {
      addImageOverlay(map);
    }
    if (background) {
      addBackground(map);
    }
    init3DMap(map);
  }
};
const hide3DMapDashed = () => {
  if (layerStorage.dashedLayer && layerStorage.map) {
    layerStorage.map.removeLayer(layerStorage.dashedLayer);
  }
  if (layerStorage.dashedPane && layerStorage.dashedPane.parentNode) {
    layerStorage.dashedPane.parentNode.removeChild(layerStorage.dashedPane);
  }
};
const hide3DMapCities = () => {
  if (layerStorage.cityMarkers.length && layerStorage.map) {
    layerStorage.cityMarkers.forEach(marker => {
      layerStorage.map.removeLayer(marker);
    });
  }
  if (layerStorage.citiesPane && layerStorage.citiesPane.parentNode) {
    layerStorage.citiesPane.parentNode.removeChild(layerStorage.citiesPane);
  }
};
const hide3DMapWeather = () => {
  if (layerStorage.weatherMarkers.length && layerStorage.map) {
    layerStorage.weatherMarkers.forEach(marker => {
      layerStorage.map.removeLayer(marker);
    });
  }
  if (layerStorage.weatherPane && layerStorage.weatherPane.parentNode) {
    layerStorage.weatherPane.parentNode.removeChild(layerStorage.weatherPane);
  }
};
const hide3DMapImage = () => {
  if (layerStorage.imagePane) {
    gsap.to(layerStorage.imagePane, {
      opacity: 0,
      duration: 0.375,
      onComplete: () => {
        if (layerStorage.imageOverlay && layerStorage.map) {
          layerStorage.map.removeLayer(layerStorage.imageOverlay);
        }
        if (layerStorage.imagePane && layerStorage.imagePane.parentNode) {
          layerStorage.imagePane.parentNode.removeChild(layerStorage.imagePane);
        }
      }
    });
  }
};
const hide3DMapBackground = () => {
  if (layerStorage.map) {
    addBackground(layerStorage.map, {
      stops: gradientDefaults.stops
    });
  }
};
const hide3DMap = () => {
  hide3DMapDashed();
  hide3DMapCities();
  hide3DMapWeather();
  hide3DMapImage();
  hide3DMapBackground();
};
const show3DMapDashed = () => {
  if (layerStorage.dashedLayer && layerStorage.map) {
    if (layerStorage.dashedPane && !layerStorage.dashedPane.parentNode) {
      layerStorage.map.getPane('mapPane').appendChild(layerStorage.dashedPane);
    }
    layerStorage.dashedLayer.addTo(layerStorage.map);
  }
};
const show3DMapCities = () => {
  if (layerStorage.cityMarkers.length && layerStorage.map) {
    if (layerStorage.citiesPane && !layerStorage.citiesPane.parentNode) {
      layerStorage.map.getPane('mapPane').appendChild(layerStorage.citiesPane);
    }
    layerStorage.cityMarkers.forEach(marker => {
      marker.addTo(layerStorage.map);
    });
  }
};
const show3DMapWeather = () => {
  if (layerStorage.weatherMarkers.length && layerStorage.map) {
    if (layerStorage.weatherPane && !layerStorage.weatherPane.parentNode) {
      layerStorage.map.getPane('mapPane').appendChild(layerStorage.weatherPane);
    }
    layerStorage.weatherMarkers.forEach(marker => {
      marker.addTo(layerStorage.map);
    });
  }
};
const show3DMapImage = () => {
  if (layerStorage.imageOverlay && layerStorage.map) {
    if (layerStorage.imagePane && !layerStorage.imagePane.parentNode) {
      layerStorage.map.getPane('mapPane').appendChild(layerStorage.imagePane);
    }
    layerStorage.imageOverlay.addTo(layerStorage.map);
  }
  if (layerStorage.imagePane) {
    gsap.to(layerStorage.imagePane, {
      opacity: 1,
      duration: 0.375
    });
  }
};
const show3DMapBackground = () => {
  if (layerStorage.map) {
    addBackground(layerStorage.map, {
      stops: gradientCMS.stops
    });
  }
};
const show3DMap = () => {
  show3DMapBackground();
  show3DMapDashed();
  show3DMapCities();
  show3DMapWeather();
  show3DMapImage();
  show3DMapBackground();
};
Object.assign(svs.lyckoplatsen.components.shared_map, {
  init3DMap,
  hide3DMap,
  hide3DMapDashed,
  hide3DMapCities,
  hide3DMapWeather,
  hide3DMapImage,
  show3DMap,
  show3DMapDashed,
  show3DMapCities,
  show3DMapWeather,
  show3DMapImage,
  addDashedSwedenBorder,
  addStaticCityMarkers,
  addWeather,
  addImageOverlay,
  addBackground,
  add3DMap
});

 })(window);